var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cancel_box"},[(_vm.label)?_c('p',{staticClass:"cancel_box--label"},[_vm._v(_vm._s(_vm.label))]):_vm._e(),_vm._v(" "),(_vm.heading)?_c('p',{staticClass:"cancel_box--heading"},[_vm._v(_vm._s(_vm.heading))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"mt-50"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }